import { Check } from 'lucide-react';
import {
  MCPTypeBadge,
  MCPTransportBadge,
  MCPStatusIndicator,
  MCPPublisherFilterOption,
  MCPVersionFilterOption,
  McpRiskFilterOption,
} from '@/components/shared/mcp';

export {
  MCPPublisherFilterOption,
  MCPVersionFilterOption,
  McpRiskFilterOption,
};

interface UserFilterOptionProps {
  userId: string;
  userName: string | null;
  userEmail: string | null;
  isSelected: boolean;
}

export function MCPUserFilterOption({
  userId,
  userName,
  userEmail,
  isSelected,
}: UserFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <span className="text-sm font-medium truncate">
          {userName || userEmail || userId}
        </span>
        {userName && userEmail && (
          <span className="text-xs text-muted-foreground truncate">
            {userEmail}
          </span>
        )}
      </div>
    </div>
  );
}

interface TypeFilterOptionProps {
  type: string;
  isSelected: boolean;
}

export function MCPTypeFilterOption({
  type,
  isSelected,
}: TypeFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPTypeBadge type={type as 'local' | 'remote'} />
    </div>
  );
}

interface StatusFilterOptionProps {
  value: string;
  isSelected: boolean;
}

export function MCPStatusFilterOption({
  value,
  isSelected,
}: StatusFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPStatusIndicator runningCount={value === 'running' ? 1 : 0} />
    </div>
  );
}

interface TransportFilterOptionProps {
  transport: string;
  isSelected: boolean;
}

export function MCPTransportFilterOption({
  transport,
  isSelected,
}: TransportFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <MCPTransportBadge transport={transport} />
    </div>
  );
}
